// extracted by mini-css-extract-plugin
export var caretAnchor = "_v4-0";
export var dropdownContent = "_v4-1";